import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationRCSModel } from '../models/configuration';
import { ConfigurationService } from './configuration.service';
import { EndpointsService } from './endpoints.service';
import { ModalControlService } from './modal-control.service';
import { UiBlockService } from './ui-block.service';

@Injectable({
  providedIn: 'root'
})
export class CoordenateService {

  public rcsList : ConfigurationRCSModel[] = [];
  public activeRCS : ConfigurationRCSModel = new ConfigurationRCSModel;

  constructor(private http: HttpClient,
    private endpointService: EndpointsService,
    private uiBlock: UiBlockService,
    private modalService: ModalControlService) {
     }

  setRCSActive(rcs: ConfigurationRCSModel): void{
    this.rcsList.forEach(el => {
      if(rcs.id == el.id){
        el.isactive = true;
      }
      else{
        el.isactive = false;
      }
    })
    this.activeRCS = rcs;
  }

  getActiveRCS() : ConfigurationRCSModel {
    let toReturn : ConfigurationRCSModel = new ConfigurationRCSModel();
    this.rcsList.forEach(el => {
      if(el.isactive){
        toReturn = el;
      }
    });
    return toReturn;
  }
}
